import { Card, Col, Row } from 'antd';
import React from 'react'

function BankChangeHistory() {
  return (
    <Card title="Bank Change History">
      <Row justify="center">
        <Col><p>This bank account is not associated with a bank change</p></Col>
      </Row>
    </Card>
  )
}

export default BankChangeHistory;
